<template>
  <div>
    <el-image :src="require('@/assets/img/s_top_06.png')" ></el-image>
  </div>
  <el-image :src="require('@/assets/img/bj_ej.png')" style="z-index: -100;position: absolute;"></el-image>
  <div class="bodyDiv">
    <div style="margin-right: 0">
      <!--      传来的参数id值是{{id}}中英文状态：{{lan=="中文"?"你好":'hello'}}-->
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t("Nav.sy") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.djyd") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Nav.djyd_xxyw") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contentDiv">
      <div class="leftDiv">
        <el-menu
            default-active="/part/study"
            @select="handleSelect"
            router="true">

          <el-menu-item index="/part/study"><span>{{ $t("Nav.djyd_xxyw") }}</span></el-menu-item>
          <el-menu-item index="/part/basic"><span>{{ $t("Nav.djyd_jbgk") }}</span></el-menu-item>
          <el-menu-item index="/part/news"><span>{{ $t("Nav.djyd_dqdt") }}</span></el-menu-item>
        </el-menu>

      </div>
      <div class="rightDiv">

        <div>
          <div v-show="!isDetail">
            <div style="min-height: 60vh">
              <div v-for="(item,index) in result.data.rows" :key="index" class="item" @click="getDetailNew(index)">
                <img :src="imgWeb+item.url"/>
                <div>

                  <h2 v-if="lan=='zh'">{{ item.title }}</h2>
                  <h2 v-else="">{{ item.titleEn }}</h2>
                  <p>{{ $t("Comm.fbsj") }}：{{ item.createTime }}</p>
                </div>

              </div>
            </div>

            <div class="divFy" v-if="result.data.total>2">
              <el-pagination
                  :page-size="10"
                  :pager-count="6"
                  layout="prev, pager, next"
                  :total="result.data.total"
                  @current-change="getList"
                  style="--el-color-primary: #D71634;"
              />
            </div>
            <div>

              <span v-if="lan=='zh'" v-html="infozn"></span>
              <span v-else v-html="infoEN"></span>

            </div>
          </div>
          <div v-show="isDetail">

            <div v-if="lan=='zh'">

              <span v-html="info.content"></span>
            </div>
            <div v-else>
              <span v-html="info.contentEn"></span>
            </div>

            <div class="backDiv">
              <p @click="doBack">{{ $t("Comm.back") }}</p>
            </div>
          </div>
        </div>

        <span v-if="lan=='zh'" v-html="infoZH">
        </span>
        <span v-else v-html="infoEN">
        </span>
      </div>
    </div>
  </div>

</template>

<script setup>
import {ref, toRef, computed, reactive, onMounted} from 'vue'
import {useI18n} from 'vue-i18n'//要在js中使用国际化
import { useStore } from 'vuex'
import {axiosGet} from "../../api/api"; // 引入useStore 方法

const {locale} = useI18n()
const store = useStore()  // 该方法用于返回store 实例



const infoZH =  ""
const infoEN = ""
let lan = computed(() => {
  return locale.value
})
let imgWeb=window.api.apiURL+'prod-api';



function handleSelect(keyPath) {
  store.state.keyPath=keyPath;
}

let result = reactive({'data': {}})

let isDetail = ref(false);
let info = reactive({})

function getDetailNew(posiotion) {
  // router.to
  // router.push({path:'/technology/achievements2', params:{id:year}})
  // store.state.detail = result.data[posiotion];
  // router.push({name: 'newsDetail'})

  info = result.data.rows[posiotion]
  isDetail.value = true
  // router.push(`/technology/achievements2?id=${year}`);
}

onMounted(() => {
  getList(1)
})

function getList(currentpage) {

  console.log("当前是第几页" + currentpage + locale.value)
  // classify（1：图片，2：中文，3：英文，4：中英文）
  let classify = 2;
  if (locale.value == 'zh') {
    classify = 2;
  } else {
    classify = 3;
  }
  axiosGet("/prod-api/system/result/getArticleList", {"type": 60, "classify": classify,'pageNum':currentpage,'pageSize':10}).then(res => {
    console.log(res)
    result.data = res.data
  })
}

function doBack() {
  // router.back()
  isDetail.value = false
}

</script>

<style scoped>
.item {
  display: flex;
  padding: 5vh;
  border-bottom: 1px solid #bcbec2;
}

.item img {
  width: 20vw;
  height: 10vw;
  margin-right: 2vw;
}

</style>
